export default "__VITE_ASSET__BQRD9thn__"